import { ReportingTypeEnum } from '@quadminds/shared/commons';
import { OrganizationSettingsEnum } from '../../enums';

export interface IOrganizationSettingsSchema<T> {
    organizationId: string;
    settings: { [key in OrganizationSettingsEnum]: T | unknown } & { reportingType: ReportingTypeEnum };
}
